export default __webpack_public_path__ + "static/form-multiple-action-buttons-dont-1836371c16a4aab2ffb2fffdb7523833d8decf6e6a02cc2be83380dc10b44440.png";